import { Box, ContentBlock, Stack } from 'braid-design-system';

import { FeaturePromoBlock } from 'src/components/FeaturePromoBlock/FeaturePromoBlock';
import Image5 from 'src/images/products/job-ad-branding.png';
import Image2 from 'src/images/products/job-ad-integration.png';
import Image7 from 'src/images/products/job-ad-live.png';
import Image1 from 'src/images/products/job-ad-products.png';
import Image6 from 'src/images/products/job-ad-track-spending.png';
import Image4 from 'src/images/products/job-category.png';
import Image3 from 'src/images/products/search-location.png';

import { SolutionsWrapper } from '../../components/SolutionsWrapper';

export const JobPosting = () => (
  <SolutionsWrapper page="SEEK Job Posting">
    <ContentBlock>
      <Box paddingX={['gutter', 'none']} paddingY={['none', 'xlarge']}>
        <Stack space={['xlarge', 'xxlarge']} dividers="regular">
          <FeaturePromoBlock
            title="Choose the SEEK ad that best suits your needs"
            text="Access SEEK’s full suite of ad products to select the one most suited to your role and hiring needs – without leaving your recruitment software."
            image={{
              url: Image1,
            }}
          />
          <FeaturePromoBlock
            title="Know the cost of your ad up front"
            text="SEEK’s pricing visibility feature lets you know the cost of your ad and how you will be billed at the point of posting on your recruitment software."
            image={{
              url: Image2,
            }}
            reverse
          />
          <FeaturePromoBlock
            title="Find the right person through targeted ads"
            text="Target the most relevant candidates by advertising your role using granular location, down to town or suburb level."
            image={{
              url: Image3,
            }}
          />
          <FeaturePromoBlock
            title="Get recommendations to optimise your ad"
            text="Guided by SEEK's powerful data, category recommendations help you improve ad performance."
            image={{
              url: Image4,
            }}
            reverse
          />
          <FeaturePromoBlock
            title="Manage your branding assets in one place"
            text="Branding management allows for any assets stored in your SEEK account – like logos and cover images – to reflect in your recruitment software."
            image={{
              url: Image5,
            }}
          />
          <FeaturePromoBlock
            title="Easily track your spending"
            text="SEEK’s billing reference allows you to monitor and reconcile the cost of your job ads."
            image={{
              url: Image6,
            }}
            reverse
          />
          <FeaturePromoBlock
            title="Know what your ad will look like before it goes live"
            text="Use our job ad preview tool to review and edit your job ad before posting it."
            image={{
              url: Image7,
            }}
          />
        </Stack>
      </Box>
    </ContentBlock>
  </SolutionsWrapper>
);
